// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rCfH","label":"styles_label__1H7lt"};